export default __webpack_public_path__ + "static/media/bRing.0526ac5e.jpg";